export enum LIST_TYPE_ID {
    STICKINESS = 0,
    BETS = 2,
    ACTIVE_USERS = 1
}